import React, { useEffect, useState } from "react"
import { IClientCurrencyRate } from "../../../../types/client/IClientCurrencyRate"
import { CurrencyPicker } from "../../element/fields/CurrencyPicker"
import { IErrorModel } from "../../../../types/error/IErrorModel"
import { CommonInput } from "../../element/fields/CommonInput"
import * as TrinityAPI from "../../../../requests/TrinityAPI"
import { getFieldError } from "../../CommonHelper"

export const ClientCurrencyRatePopUp: React.FC<{
  rate: IClientCurrencyRate | undefined
  hidePopUp: () => void
}> = ({ rate, hidePopUp }) => {
  const [localRate, setLocalRate] = useState<IClientCurrencyRate>()
  const [sending, setSending] = useState(false)
  const [errors, setErrors] = useState<IErrorModel>()

  useEffect(() => {
    setLocalRate(rate)
  }, [rate])

  const submit = () => {
    if (!localRate || sending) return
    setSending(true)
    const rateToSubmit = { ...localRate }
    rateToSubmit.value = rateToSubmit.value?.replaceAll(" ", "")
    TrinityAPI.createClientCurrencyRate(rateToSubmit, response => {
      if (response.status === 200) {
        setSending(false)
        hidePopUp()
      } else {
        setErrors(response.data)
        setSending(false)
      }
    })
  }

  return (
    <section className="popup-forms index-top">
      <div className="container-popup-forms">
        <button className="close-btn-card" onClick={hidePopUp} />
        <div className="popup-card">
          <h4 className="heading-chapter">Надбавка к курсу</h4>
          <CurrencyPicker
            label={"Валюта"}
            name={"currency"}
            errorModel={errors}
            initValue={localRate?.currency}
            _callback={v => setLocalRate({ ...localRate, currency: v })}
          />
          <ul className="user_list-inn">
            <li className="user_item-inn">
              <input
                type="radio"
                className="checkbox"
                id="AMOUNT"
                value="AMOUNT"
                checked={localRate?.type === "AMOUNT"}
                onChange={e => setLocalRate({ ...localRate, type: e.target.value })}
              />
              <label htmlFor="AMOUNT" className="user_item-check">
                Сумма в копейках
              </label>
            </li>
            <li className="user_item-inn">
              <input
                type="radio"
                className="checkbox"
                id="PCT"
                value="PCT"
                checked={localRate?.type === "PCT"}
                onChange={e => setLocalRate({ ...localRate, type: e.target.value })}
              />
              <label htmlFor="PCT" className="user_item-check">
                Процент
              </label>
            </li>
          </ul>
          {getFieldError(errors, "type") ? <p className="error-form">{getFieldError(errors, "type")}</p> : <></>}

          <CommonInput
            typeName={"number"}
            label={"Число"}
            placeholder={"Сумма в коп. или процент"}
            name={"value"}
            value={localRate?.value}
            errorModel={errors}
            _callback={v => setLocalRate({ ...localRate, value: v })}
          />
          <div className="flex-row-24">
            <button className="btn" onClick={submit}>
              {sending ? "Подождите..." : "Сохранить"}
            </button>
            <button className="btn grey-btn" onClick={hidePopUp}>
              Отменить
            </button>
          </div>
        </div>
      </div>
    </section>
  )
}
